import { render, staticRenderFns } from "./FormNews.vue?vue&type=template&id=10f36f41&scoped=true&"
import script from "./FormNews.vue?vue&type=script&lang=js&"
export * from "./FormNews.vue?vue&type=script&lang=js&"
import style0 from "./FormNews.vue?vue&type=style&index=0&id=10f36f41&scoped=true&lang=css&"
import style1 from "./FormNews.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f36f41",
  null
  
)

export default component.exports